const requests = {
  allCountries: `/covid-19/countries`,
  allCountriesData: `/covid-19/all`,
  allCountriesHistory: `/covid-19/historical/all?lastdays=`,
};

export default requests;
